// TODO - Use a Divider MUI component instead of self closing Grid
import { Fragment } from 'react';
import { useHistory } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { UP_AI_BRAND_NAME } from '../../app/constants/constants';
import { selectRecipeCreationOption } from '../../app/homepage/homepage.slice';
import { RecipeModeConfig } from '../../app/recipeCreation/createRecipe.types';
import { useAppDispatch } from '../../app/store/hooks';
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { AIGeneratedRecipeIcon, CreateFromScratchIcon, DialogCloseIcon, DuplicateIcon } from '../../iconRef/recipeCreationPopupIcons';
import { EventLogsEnum } from '../../utils/events';
import styles from "./recipeCreationPopup.module.css";
import { CreationModeEnum } from './utils/constants';

type Props = {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

const recipeModeConfig: Array<RecipeModeConfig> = [
    {
        title: 'Create with AI',
        id: "mode-create-with-ai",
        rank: 0,
        subtitle: `Generate recipe using ${UP_AI_BRAND_NAME}`,
        icon: <AIGeneratedRecipeIcon />,
        recipeCreationOption: CreationModeEnum.AI_GENERATED
    },
    {
        title: 'Duplicate recipe',
        id: "mode-duplicate-recipe",
        rank: 1,
        subtitle: 'Duplicate existing recipe and customize according to you',
        icon: <DuplicateIcon />,
        recipeCreationOption: CreationModeEnum.DUPLICATE_RECIPE
    },
    {
        title: 'Build from scratch',
        id: "mode-build-from-scratch",
        rank: 2,
        subtitle: 'Build your own recipe from scratch',
        icon: <CreateFromScratchIcon />,
        recipeCreationOption: CreationModeEnum.CREATED_FROM_SCRATCH
    }
].sort((a, b) => a.rank - b.rank);

const RecipeCreationPopup = ({ open, setOpen }: Props): JSX.Element => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { logRecipeEdit } = useLogRecipeEdit();

    const handleClose = () => {
        setOpen(false);
        dispatch(selectRecipeCreationOption(null));
    }

    const handleRecipeCreationMode = (mode: string) => {
        logRecipeEdit(EventLogsEnum.APP_RECIPE_CREATION_INITIALISED, {
            eventData: { creationType: mode }
        })
        history.push(`/user-create-recipe/`);
        dispatch(selectRecipeCreationOption(mode));
    }

    const lastModeIndex = recipeModeConfig.length - 1;

    return (
        <Dialog
            fullWidth
            onClose={handleClose}
            open={open}
            PaperProps={{ classes: { root: styles.dialog_paper } }}
        >
            <Grid alignItems="center" className={styles.container} container
                direction="column" justifyContent="center">
                <IconButton className={styles.icon_btn} onClick={handleClose}><DialogCloseIcon /></IconButton>
                <>
                    {
                        recipeModeConfig.map((mode: RecipeModeConfig, index: number) => (
                            <Fragment key={mode.title}>
                                <Grid alignItems="center" className={styles.mode_container} container
                                    direction="row" id={mode.id} justifyContent="center"
                                    onClick={() => handleRecipeCreationMode(mode.recipeCreationOption)} spacing={2}>
                                    <Grid item sm={2} xs={4}>
                                        {mode.icon}
                                    </Grid>
                                    <Grid container item sm={4}
                                        xs={8}>
                                        <Grid container direction="column" justifyContent="center"
                                            spacing={2}>
                                            <Grid xs>
                                                <Typography component="div" gutterBottom variant="body5">
                                                    {mode.title}
                                                </Typography>
                                                <Typography color="#000" variant="body2paralell">
                                                    {mode.subtitle}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {index !== lastModeIndex && <Grid className={styles.divider} item />}
                            </Fragment>
                        )
                        )
                    }
                </>
            </Grid>
        </Dialog >
    )
}

export default RecipeCreationPopup;